module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel06_770_280_ja-2d01f56798f8c036bbb18e87ce54baf0.jpg";